export const Data = [
'John',
'David',
'Rachel',
"Edwards",
"Christopher",
"Perez",
"Thomas",
"Baker",
"Sara",
"Moore",
"Chris",
"Bailey",
"Roger",
"Johnson",
"Marilyn",
"Thompson",
"Anthony",
"Evans",
"Julie",
"Hall",
"Paula",
"Phillips",
"Annie",
"Hernandez"
]